import { render, staticRenderFns } from "./FenceGuardMeasurement.vue?vue&type=template&id=53065435&scoped=true&"
import script from "./FenceGuardMeasurement.vue?vue&type=script&lang=js&"
export * from "./FenceGuardMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./FenceGuardMeasurement.vue?vue&type=style&index=0&id=53065435&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53065435",
  null
  
)

/* custom blocks */
import block0 from "./FenceGuardMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports